import { useEffect, useState } from "react";

const quickLinks = [
  { label: "实时快报", href: "#live" },
  { label: "进展时间线", href: "#timeline" },
  { label: "热点话题榜", href: "#rank" },
  { label: "话题频道", href: "#channels" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <footer className="w-full bg-primary-800 text-background-100">
        <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-14">
          <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
            <div>
              <a href="#top" className="inline-flex items-center gap-2">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-600 text-lg">
                  <i className="ri-flashlight-fill"></i>
                </span>
                <span className="font-heading text-lg font-bold text-background-50">
                  吃瓜<span className="text-accent-400">前线</span>
                </span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/85">
                把散落在各处的热点进展按时间线同步整理，事件再长也能快速对齐后续。随时刷新，都有新变化。
              </p>
            </div>

            <nav aria-label="站内导航">
              <h4 className="text-sm font-semibold text-background-50">内容导航</h4>
              <ul className="mt-4 space-y-2.5 text-sm text-background-200/85">
                {quickLinks.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="hover:text-background-50 transition-colors whitespace-nowrap">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div>
              <h4 className="text-sm font-semibold text-background-50">联系与交流</h4>
              <p className="mt-4 text-sm text-background-200/85">爆料 / 指正 / 合作来信：</p>
              <a
                href="mailto:hello@chigua-qianxian.example"
                className="mt-2 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors"
              >
                <i className="ri-mail-send-line"></i>
                hello@chigua-qianxian.example
              </a>
              <div className="mt-4 flex flex-wrap gap-2">
                {["理性吃瓜", "关注进展", "不信谣"].map((t) => (
                  <span key={t} className="rounded-full bg-background-50/15 px-3 py-1 text-xs text-background-200">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs text-background-300">
            <span>© 2026 吃瓜前线 · 仅供信息整理与交流</span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i>
              转载以可查证信源为准
            </span>
          </div>
        </div>
      </footer>

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-colors fade-up cursor-pointer"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </>
  );
}